// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "styling": {
      "column": {
        "default": null,
        "name": "styling",
        "null": true,
        "type": "text"
      },
      "name": "styling",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "Styling",
  "collectionKey": "stylings",
  "collectionName": "stylings",
  "i18nKey": "styling",
  "camelizedLower": "styling",
  "name": "Styling",
  "nameDasherized": "styling",
  "pluralName": "stylings",
  "ransackable_associations": [
    {
      "className": "Styling::Audit",
      "collectionName": "styling_audits",
      "foreignKey": "styling_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "StylingAudit",
      "through": null
    },
    {
      "className": "ContentAbsoluteContainer",
      "collectionName": "content_absolute_containers",
      "foreignKey": "styling_id",
      "name": "content_absolute_containers",
      "macro": "has_many",
      "resource_name": "ContentAbsoluteContainer",
      "through": null
    },
    {
      "className": "Styling::Audit",
      "collectionName": "styling_audits",
      "foreignKey": "styling_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "StylingAudit",
      "through": null
    },
    {
      "className": "Styling::Translation",
      "collectionName": null,
      "foreignKey": "styling_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Styling::Translation",
      "collectionName": null,
      "foreignKey": "styling_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "styling",
      "column": {
        "default": null,
        "name": "styling",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "styling",
  "primaryKey": "id"
}

/** Frontend model for Styling. */
export default class Styling extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  styling() {
    return this.readAttributeUnderscore("styling")
  }

  /** @returns {boolean} */
  hasStyling() {
    const value = this.styling()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }
}
